/**
 * Commerce Studio — K-Beauty UAE premium header
 * Sticky state, mobile drawer, expandable search.
 * Minimal JS, no dependencies.
 */
(function () {
  "use strict";

  const header = document.getElementById("cs-kb-header");
  if (!header) return;

  const root = document.documentElement;
  const drawer = document.getElementById("cs-kb-drawer");
  const drawerOpeners = header.querySelectorAll("[data-cs-kb-open-drawer]");
  const drawerClosers = document.querySelectorAll("[data-cs-kb-close-drawer]");
  const searchToggle = header.querySelector("[data-cs-kb-search-toggle]");
  const searchPanel = header.querySelector("[data-cs-kb-search]");
  const searchInput = header.querySelector("[data-cs-kb-search-input]");
  const megaTriggers = header.querySelectorAll("[data-cs-kb-mega]");
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function setHeaderHeights() {
    const height = Math.ceil(header.getBoundingClientRect().height);
    root.style.setProperty("--header-height", `${height}px`);
    root.style.setProperty("--header-group-height", `${height}px`);
    root.style.setProperty("--cs-kb-header-height", `${height}px`);
  }

  function onScroll() {
    const compact = window.scrollY > 24;
    header.classList.toggle("is-scrolled", compact);
    header.setAttribute("data-sticky-state", compact ? "compact" : "full");
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.hidden = false;
    requestAnimationFrame(() => drawer.classList.add("is-open"));
    document.body.classList.add("cs-kb-drawer-open");
    const closeBtn = drawer.querySelector("[data-cs-kb-close-drawer]");
    closeBtn?.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    document.body.classList.remove("cs-kb-drawer-open");
    const finish = () => {
      if (!drawer.classList.contains("is-open")) drawer.hidden = true;
    };
    if (reducedMotion) finish();
    else setTimeout(finish, 220);
  }

  function toggleSearch(force) {
    if (!searchPanel) return;
    const open = typeof force === "boolean" ? force : !searchPanel.classList.contains("is-open");
    searchPanel.classList.toggle("is-open", open);
    searchToggle?.setAttribute("aria-expanded", open ? "true" : "false");
    if (open) {
      searchInput?.focus();
    }
  }

  function closeMegas() {
    megaTriggers.forEach((btn) => {
      btn.setAttribute("aria-expanded", "false");
      const panel = document.getElementById(btn.getAttribute("aria-controls") || "");
      panel?.classList.remove("is-open");
    });
  }

  drawerOpeners.forEach((btn) => btn.addEventListener("click", openDrawer));
  drawerClosers.forEach((btn) => btn.addEventListener("click", closeDrawer));

  searchToggle?.addEventListener("click", (event) => {
    event.preventDefault();
    event.stopPropagation();
    toggleSearch();
  });

  megaTriggers.forEach((btn) => {
    btn.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      const panelId = btn.getAttribute("aria-controls");
      const panel = panelId ? document.getElementById(panelId) : null;
      const expanded = btn.getAttribute("aria-expanded") === "true";
      closeMegas();
      if (!expanded && panel) {
        btn.setAttribute("aria-expanded", "true");
        panel.classList.add("is-open");
      }
    });
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeDrawer();
      toggleSearch(false);
      closeMegas();
    }
  });

  document.addEventListener("click", (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (!header.contains(target)) closeMegas();
    if (
      searchPanel?.classList.contains("is-open") &&
      !searchPanel.contains(target) &&
      !searchToggle?.contains(target)
    ) {
      toggleSearch(false);
    }
  });

  drawer?.querySelectorAll("[data-cs-kb-accordion]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const expanded = btn.getAttribute("aria-expanded") === "true";
      btn.setAttribute("aria-expanded", expanded ? "false" : "true");
      const panel = document.getElementById(btn.getAttribute("aria-controls") || "");
      panel?.classList.toggle("is-open", !expanded);
    });
  });

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", setHeaderHeights);
  setHeaderHeights();
  onScroll();

  if (typeof ResizeObserver !== "undefined") {
    new ResizeObserver(setHeaderHeights).observe(header);
  }
})();
